import Alert from '@ramsey-design-system/alert';
import { InformationIcon } from '@ramsey-design-system/icons';
import Text from '@ramsey-design-system/text';

interface MatcherPhoneVerificationCountDownProps {
  phoneVerificationCountDown: number;
}

export function MatcherPhoneVerificationCountDownAlert({
  phoneVerificationCountDown
}: Readonly<MatcherPhoneVerificationCountDownProps>) {
  return (
    <Alert
      data-testid={'matcher-phone-verification-countdown-alert'}
      role={'alert'}
      className="mb-4"
      icon={InformationIcon}
    >
      <Text>
        If you need another code, you can try again in{' '}
        <b>
          {phoneVerificationCountDown +
            ' ' +
            (phoneVerificationCountDown === 1 ? 'second' : 'seconds')}
        </b>
      </Text>
    </Alert>
  );
}
